import logger from '@/logger/logger'

export const callAPI = async (apiPath: string, hasApiError: (data) => void): Promise<Record<string, unknown>> => {
  try {
    const apiResponse = await fetch(apiPath)
    const apiData = (await apiResponse.json()) as Record<string, unknown>
    if (apiResponse.status < 400) {
      return apiData
    }

    hasApiError(true)
  } catch (e) {
    logger.error(e)
    hasApiError(true)
  }
}
